import * as yup from 'yup';
import { isValidDate } from './isValidDate';

const addDateValidation = (t) => (yup.string()
  .required(t('error.requiredField'))
  .matches(/^\d{4}-\d{2}-\d{2}$/, t('error.invalidDateFormat'))
  .test('is-valid-date', t('error.invalidField'), isValidDate));

export default addDateValidation;
